import React from 'react';

const ShowMoreLink = ({ path, onClick, text }) => (
  <a className="f--2 fw4 near-black link pointer underline-hover" href={path} onClick={onClick}>
    {text}
  </a>
);

export default ShowMoreLink;
